import React, { Component } from 'react';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import PortalAuth from '../../../utils/Auth';
import Loading from '../../../components/loading';
import styles from './changePassword.module.scss';
import Button from '../../../components/button/button';
import { changeCurrentPage } from '../../../general_redux/actions';

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: '',
      confirmPassword: '',
      oldPassword: '',
      passwordMatches: true,
      errors: {
        oldPassword: true,
        newPassword: true,
        confirmPassword: true,
        invalidOtp: false
      },
      invalidOldPassword: false,
      invalidNewPassword: false,
      otpInput: '',
      loadingStatus: false
    };
  }

  componentDidMount() {
    const { actionUpdateCurrentPage } = this.props;
    actionUpdateCurrentPage('Airport Portal');
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, {
        [name]: true
      })
    })));
  }

  checkPasswordMatch = () => {
    const { newPassword, confirmPassword } = this.state;
    if (newPassword !== confirmPassword) {
      this.setState({
        passwordMatches: (newPassword === confirmPassword)
      });
    } else {
      this.setState({ passwordMatches: true });
    }
  }

  checkEmptyFields = () => {
    const { oldPassword, newPassword, confirmPassword } = this.state;
    if (oldPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          oldPassword: false
        })
      }));
    } else if (newPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          newPassword: false
        })
      }));
    } else if (confirmPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          confirmPassword: false
        })
      }));
    }
  }

  handleErrors = () => {
    this.setState({ invalidOldPassword: true, loadingStatus: false });
  }

  // eslint-disable-next-line react/sort-comp
  handleAuthError(error) {
    this.setState({ loadingStatus: false });
    mixpanel.track(error.code);
    switch (error.code) {
      case 'NotAuthorizedException':
      case 'UserNotFoundException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {

          })
        }));
        break;
      case 'CodeMismatchException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            invalidOtp: true
          })
        }));
        break;
      case 'LimitExceededException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {

          })
        }));
        break;
      case 'InvalidPasswordException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {

          })
        }));
        break;
      case 'InvalidParameterException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {

          })
        }));
        break;
      default:
        break;
    }
  }

  handleResetPassword = (e) => {
    this.setState({ loadingStatus: true });
    e.preventDefault();
    const { oldPassword,
      newPassword,
      confirmPassword,
      passwordMatches } = this.state;
    const { profile, history } = this.props;

    this.checkPasswordMatch();
    if (!passwordMatches) {
      this.setState({ loadingStatus: false });
      return;
    }

    if (oldPassword === '' || newPassword === '' || confirmPassword === '') {
      this.setState({ loadingStatus: false });
      this.checkEmptyFields();
      return;
    }

    const authDetails = new AuthenticationDetails({
      Username: profile.user.email,
      Password: oldPassword
    });

    const cognitoUser = new CognitoUser({
      Username: profile.user.email,
      Pool: PortalAuth.getInstance().getUserPool()
    });

    this.setState({ cognitoUser });
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: (result) => {
        PortalAuth.getInstance().setAuthToken(result.getAccessToken().getJwtToken());
        PortalAuth.getInstance().setIDToken(result.getIdToken().getJwtToken());
        axios.defaults.baseURL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') && window.location.hostname.indexOf('app.') === -1
          ? process.env.REACT_APP_BACKEND_HOST
          : `https://backend.${window.location.hostname}/api`;
        cognitoUser.changePassword(oldPassword, newPassword, (err) => {
          if (err) {
            this.setState({ invalidNewPassword: true, loadingStatus: false });
            return;
          }
          this.setState({ loadingStatus: false });
          history.push('/');
        });
      },
      onFailure: this.handleErrors,
      mfaRequired: this.handleMFA
    });
  }

  handleMFA = () => {
    const { cognitoUser, oldPassword, newPassword, otpInput } = this.state;
    const { history } = this.props;
    cognitoUser.sendMFACode(otpInput, {
      onSuccess: () => {
        cognitoUser.changePassword(oldPassword, newPassword, () => {
          this.setState({ loadingStatus: false });
          history.push('/');
        });
      },
      onFailure: err => this.handleAuthError(err)
    });
  };

  userSignIn = () => {
    const { oldPassword } = this.state;
    const { profile } = this.props;
    const cognitoUser = new CognitoUser({
      Username: profile.user.email,
      Pool: PortalAuth.getInstance().getUserPool()
    });
    this.setState({ cognitoUser });
    const authDetails = new AuthenticationDetails({
      Username: profile.user.email,
      Password: oldPassword
    });
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: () => {
      },
      onFailure: this.handleAuthError,
      mfaRequired: this.handleMFA
    });
  };

  render() {
    const { errors,
      invalidOldPassword,
      invalidNewPassword,
      newPassword,
      confirmPassword,
      passwordMatches, loadingStatus } = this.state;
    return (
      <div>
        <Loading loadingStatus={loadingStatus} />
        <form name="ChangePasswordForm" className={styles.form} onSubmit={this.handleResetPassword}>
          <div className={styles.form}>
            <div className={styles.column}>
              <label htmlFor="oldPassword">
                <FormattedMessage id="authentication.force_reset_password.old_password" defaultMessage="old password" />
                <input
                  type="password"
                  name="oldPassword"
                  onChange={this.handleChange}
                  onBlur={this.checkEmptyFields}
                />
              </label>
              {errors.oldPassword ? null : (
                <div className={styles.error}>
                  <small>
                    <FormattedMessage id="authentication.login.error.password_empty" defaultMessage="This field cannot be empty" />
                  </small>
                </div>
              )}
              {invalidOldPassword ? (
                <div className={`${styles.error} ${styles.invalidPassword}`}>
                  <small>
                    <FormattedMessage id="authentication.login.error.invalid_password" defaultMessage="The password is invalid" />
                  </small>
                </div>
              ) : null}
              <label htmlFor="newPassword">
                <FormattedMessage id="authentication.force_reset_password.new_password" defaultMessage="New password" />
                <input
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={this.handleChange}
                  onBlur={this.checkEmptyFields}
                />
              </label>
              {errors.newPassword ? null : (
                <div className={styles.error}>
                  <small>
                    <FormattedMessage id="authentication.login.error.password_empty" defaultMessage="This field cannot be empty" />
                  </small>
                </div>)
              }
              {invalidNewPassword ? (
                <div className={`${styles.error} ${styles.invalidPassword}`}>
                  <small>
                    <FormattedMessage id="authentication.force_reset_password.invalid_password" defaultMessage="The password is invalid" />
                  </small>
                </div>) : null}
              <label htmlFor="confirmPassword">
                <FormattedMessage id="authentication.force_reset_password.confirm_password" defaultMessage="Confirm password" />
                <input
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={this.handleChange}
                  onBlur={this.checkPasswordMatch}
                />
              </label>
              {errors.confirmPassword ? null : (
                <div className={styles.error}>
                  <small>
                    <FormattedMessage id="authentication.login.error.password_empty" defaultMessage="This field cannot be empty" />
                  </small>
                </div>)}
              {passwordMatches ? null : (
                <div className={styles.error}>
                  <small>
                    <FormattedMessage id="authentication.force_reset_password.password_mismatch"
                      defaultMessage="Password and confirmation do not match"
                    />
                  </small>
                </div>)}
              <div className={styles.password_policy}>
                <FormattedMessage id="password_policy.title" defaultMessage="Password Policy" tagName="h5" />
                <span className={styles.text_cl}>
                  <FormattedMessage id="password_policy.intro" defaultMessage="The password must contain all of the following characteristics" />
                </span>
                <ul className={styles.text_cl}>
                  <li>
                    <FormattedMessage id="password_policy.length" defaultMessage="At least 8 characters" />
                  </li>
                  <li>
                    <FormattedMessage id="password_policy.uppercase" defaultMessage="At least one uppercase character" />
                  </li>
                  <li>
                    <FormattedMessage id="password_policy.lowercase" defaultMessage="At least one lowercase character" />
                  </li>
                  <li>
                    <FormattedMessage id="password_policy.special_char" defaultMessage="At least one special character" />
                  </li>
                  <li>
                    <FormattedMessage id="password_policy.numbers" defaultMessage="At least one number" />
                  </li>
                </ul>
              </div>
              <br />
              <br />
              <Button type="submit" translationID="authentication.force_reset_password.header" defaultText="Reset Password" />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionUpdateCurrentPage: (page) => {
    dispatch(changeCurrentPage(page));
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ChangePassword));
